import { gql } from '@apollo/client';

export const DELETE_DASHBOARD_LAYOUT = gql`
  mutation deleteDashboardLayout($id: ID!) {
    dashboardLayout: deleteDashboardLayout(id: $id) {
      id
      name
    }
  }
`;
